<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="sampleCode"
      :toolbar-config="tableToolbar"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 4"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{
        highlight: true,
        reserve: true,
        strict: true,
        trigger: 'row',
        checkMethod: ({ row }) => ['P'].includes(row.prebuiltStatus),
      }"
      @checkbox-change="onCheckboxChange"
      @checkbox-all="onCheckboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:prebuiltStatus="{ row }">
        <div>
          <el-tag
            size="mini"
            :type="
              row.prebuiltStatus == 'N'
                ? 'primary'
                : row.prebuiltStatus == 'P'
                ? 'P'
                : 'success'
            "
          >
            {{ row.v_prebuiltStatus }}
          </el-tag>
        </div>
      </template>

      <template v-slot:createBy="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>

      <template v-slot:printDate="{ row }">
        <span>{{ row.printByName }}</span>
        <br />
        <span>{{ row.printDate }}</span>
      </template>

      <template v-slot:useBy="{ row }">
        <span>{{ row.useByName }}</span>
        <br />
        <span>{{ row.useDate }}</span>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
      formData: {
        tskBy: '',
        tskByName: '',
        tskInfoCode: '',
        remark: '',
      },
      rules: {
        tskBy: [
          {
            trigger: 'change',
            required: true,
            message: this.$l('INDEX.tips_pleaseSelectData') || '请选择数据',
          },
        ],
        remark: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {},
  methods: {
    onCheckboxChange({ records, reserves }) {
      this.$emit('checkboxChange', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkboxChange', [])
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-toolbar {
    height: initial;
    margin-bottom: 12px;
  }
  .vxe-cell {
    > div {
      margin-top: 7px;
    }
  }
}
::v-deep {
  .el-tag--P {
    color: #fa561f;
    background-color: #fff2e8;
    border: #ffbb96;
  }
}
</style>
